<template>
  <v-container fluid style="margin-top: -12px">
    <v-card flat class="disable-scrollbars">
      <v-card-text>
        <v-row style="max-height: 32px">
          <v-col
            class="text-center mt-n5 blue-grey--text"
            cols="12"
            sm="12"
            md="12"
            lg="12"
            xs="12"
          >
            <v-btn-toggle v-model="icon" borderless>
<!--              <v-btn value="graphic">-->
<!--                <span class="hidden-sm-and-down blue-grey&#45;&#45;text m-size-font-12"-->
<!--                  >Gráfico</span-->
<!--                >-->

<!--                <v-icon size="14" class="blue-grey&#45;&#45;text" right-->
<!--                  >mdi-chart-bar</v-icon-->
<!--                >-->
<!--              </v-btn>-->

<!--              <v-btn value="table">-->
<!--                <span class="hidden-sm-and-down blue-grey&#45;&#45;text m-size-font-12"-->
<!--                  >Tabela</span-->
<!--                >-->

<!--                <v-icon size="14" class="blue-grey&#45;&#45;text" right-->
<!--                  >mdi-table</v-icon-->
<!--                >-->
<!--              </v-btn>-->

              <v-btn value="export" @click="showExportReport">
                <span class="hidden-sm-and-down blue-grey--text m-size-font-12"
                  >Exportar Relatório</span
                >

                <v-icon size="14" class="blue-grey--text" right
                  >mdi-chart-donut</v-icon
                >
              </v-btn>

              <v-btn value="request" @click="showRequestReport">
                <span class="hidden-sm-and-down blue-grey--text m-size-font-12"
                  >Solicitar Relatório</span
                >

                <v-icon size="14" class="blue-grey--text m-size-font-12" right
                  >mdi-format-align-justify</v-icon
                >
              </v-btn>
            </v-btn-toggle>
            <!--            <h1-->
            <!--              class="font-weight-bold blue-grey&#45;&#45;text"-->
            <!--              style="text-transform: uppercase; font-size: 16px"-->
            <!--            >-->
            <!--              Filter 1-->
            <!--            </h1>-->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import eventBus from "@/main";

export default {
  name: "FilterReport",
  data: () => ({
    icon: "graphic"
  }),
  methods: {
    showExportReport() {
      // this.drawer = !this.drawer;
      const payload = {
        dialog: true,
        drawer: true
      };
      eventBus.$emit("openDialogExportReport", payload);
    },

    showRequestReport() {
      const payload = {
        dialog: true,
        drawer: true
      };
      eventBus.$emit("openDialogRequestReport", payload);
    }
  }
};
</script>

<style scoped></style>
